import { Routes } from '@angular/router';
import { LeaveofAbsenceComponent } from './leave-of-absence.component';

export const leaveOfAbsensceRoutes: Routes = [
  {
    path: '',
    component: LeaveofAbsenceComponent
  }
];
